const GET_PERFORMANCE = 'GET_PERFORMANCE';
const GET_FILTERED_PERFORMANCE = 'GET_FILTERED_PERFORMANCE';
const GET_PERFORMANCE_LINKS = 'GET_PERFORMANCE_LINKS';
const GET_PERFORMANCE_LIST_LINKS = 'GET_PERFORMANCE_LIST_LINKS';
const GET_PERFORMANCE_BY_ID = 'GET_PERFORMANCE_BY_ID';
const FETCH_PERFORMANCE = 'FETCH_PERFORMANCE';
const REMOVE_DATA = 'REMOVE_DATA';
const SET_DATA = 'SET_DATA';
const SET_LINK = 'SET_LINK';
const REMOVE_GRID_DATA = 'REMOVE_GRID_DATA';
const FETCH_EVENTS = 'FETCH_EVENTS';
const FETCH_CLASSES = 'FETCH_CLASSES';
const UPDATE_PERF = 'UPDATE_PERF';
const GET_PERFORMANCE_FOR_SELECTOR = 'GET_PERFORMANCE_FOR_SELECTOR';
const GET_CLASS_BY_PERF_ID = 'GET_CLASS_BY_PERF_ID';
const GET_EVENT_BY_PERF_ID = 'GET_EVENT_BY_PERF_ID';
const CREATE_NEW_PERFORMANCE = 'CREATE_NEW_PERFORMANCE';
const GET_CREATED_PERFORMANCES = 'GET_CREATED_PERFORMANCES';
const GET_SUBEVENTS_FOR_MULTI = 'GET_SUBEVENTS_FOR_MULTI';
const FETCH_EVENT_CLASS = 'FETCH_EVENT_CLASS';
const FETCH_GLOBAL_COMPETITORS = 'FETCH_GLOBAL_COMPETITORS';
const FETCH_CREATE_LINKS = 'FETCH_CREATE_LINKS';
const DELETE_PERF = 'DELETE_PERF';

export default {
	GET_PERFORMANCE,
	GET_FILTERED_PERFORMANCE,
	GET_PERFORMANCE_LINKS,
	GET_PERFORMANCE_LIST_LINKS,
	GET_PERFORMANCE_BY_ID,
	FETCH_PERFORMANCE,
	REMOVE_DATA,
	SET_DATA,
	SET_LINK,
	REMOVE_GRID_DATA,
	FETCH_EVENTS,
	FETCH_CLASSES,
	UPDATE_PERF,
	CREATE_NEW_PERFORMANCE,
	GET_PERFORMANCE_FOR_SELECTOR,
	GET_CLASS_BY_PERF_ID,
	GET_EVENT_BY_PERF_ID,
	GET_CREATED_PERFORMANCES,
	GET_SUBEVENTS_FOR_MULTI,
	FETCH_EVENT_CLASS,
	FETCH_GLOBAL_COMPETITORS,
	FETCH_CREATE_LINKS,
	DELETE_PERF,
};
